import country_data from "../data/country-data";

/**
 * Get all countries with formatted data
 * @returns {Array} Formatted list of countries
 */
export const getAllCountries = () => {
  return country_data?.countries?.map((data) => ({
    value: data.id,
    label: data.name,
    ...data,
  }));
};

/**
 * Get all cities from a specific country by country ID
 * @param {number} countryId - The ID of the country
 * @returns {Array} List of all cities in the country
 */
export const getCityFromCountry = (countryId) => {
  // Find the country by ID
  const country = country_data?.countries?.find(
    (data) => data?.id === countryId
  );
  
  if (!country) return [];

  // Initialize an array to hold all cities
  let allCities = [];
  
  // Loop through each state and collect all cities
  country.states?.forEach(state => {
    if (state.cities && Array.isArray(state.cities)) {
      // Add each city to the allCities array with state information
      state.cities.forEach(city => {
        allCities.push({
          value: city.id,
          label: city.name,
          stateId: state.id,
          stateName: state.name,
          ...city
        });
      });
    }
  });
  
  return allCities;
};

/**
 * Get all states from a specific country by country ID
 * @param {number} countryId - The ID of the country
 * @returns {Array} List of all states in the country
 */
export const getStatesFromCountry = (countryId) => {
  const country = country_data?.countries?.find(
    (data) => data?.id === countryId
  );

  if (!country) return [];
  
  return country.states?.map(state => ({
    value: state.id,
    label: state.name,
    ...state
  })) || [];
};

/**
 * Get all cities from a specific state by state ID
 * @param {number} stateId - The ID of the state
 * @returns {Array} List of cities in the state
 */
export const getCitiesFromState = (stateId) => {
  // Find the state across all countries
  let targetState = null;
  
  for (const country of country_data?.countries || []) {
    const state = country.states?.find(s => s.id === stateId);
    if (state) {
      targetState = state;
      break;
    }
  }
  
  if (!targetState) return [];
  
  return targetState.cities?.map(city => ({
    value: city.id,
    label: city.name,
    ...city
  })) || [];
};
